// extracted by mini-css-extract-plugin
module.exports = {"downloadIcon":"AlphaDataResource_downloadIcon__3u_08"};